export default {
    Restart: (): void => {
        window?.location?.assign((window.initialConfig.app.baseUrlSchema || 'https') + '://' + window.initialConfig.app.baseUrl);
    }
}
